import axios from 'axios';

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, businessProfileId) {
        return axios.$get('/v1/admin/emails', {
            params: { business_profile_id: businessProfileId }
        });
    },

    store(vuexContext, data) {
        const {
            emailName,
            brandName,
            emailType,
            reciverAccountId,
            articlesFilterId,
            searchId,
            mailFrequency,
            deliverHour,
            dataFrom,
            articlesLimit,
            postsLimit,
            omitResponse,
            minLimitation,
            articlesUrl,
            extraEmails,
            competitors,
            businessProfileId
        } = data;

        const payload = {
            business_profile_id: businessProfileId,
            email_name: emailName,
            brand_name: brandName,
            email_type: emailType,
            reciver_account_id: reciverAccountId,
            search_id: searchId,
            articles_filter_id: articlesFilterId,
            mail_frequency: mailFrequency,
            deliver_hour: deliverHour,
            data_from: dataFrom,
            articles_url: articlesUrl,
            extra_emails: extraEmails,
            competitors,
            articles_limit: articlesLimit,
            posts_limit: postsLimit,
            omit_response: omitResponse,
            min_limitation: minLimitation
        };

        return axios.$post('/v1/admin/emails', payload);
    },

    update(vuexContext, data) {
        const {
            id,
            emailName,
            brandName,
            emailType,
            reciverAccountId,
            articlesFilterId,
            searchId,
            mailFrequency,
            deliverHour,
            dataFrom,
            articlesLimit,
            postsLimit,
            omitResponse,
            minLimitation,
            articlesUrl,
            extraEmails,
            competitors
        } = data;

        const payload = {
            email_name: emailName,
            brand_name: brandName,
            email_type: emailType,
            reciver_account_id: reciverAccountId,
            search_id: searchId,
            articles_filter_id: articlesFilterId,
            mail_frequency: mailFrequency,
            deliver_hour: deliverHour,
            data_from: dataFrom,
            articles_url: articlesUrl,
            extra_emails: extraEmails,
            competitors,
            articles_limit: articlesLimit,
            posts_limit: postsLimit,
            omit_response: omitResponse,
            min_limitation: minLimitation
        };

        return axios.$patch(`/v1/admin/emails/${id}`, payload);
    },

    destroy(vuexContext, id) {
        return axios.$delete(`/v1/admin/emails/${id}`);
    },

    send(vuexContext, { id, sendToMe, shouldBeReset }) {
        const payload = {
            id
        };

        if (shouldBeReset) {
            payload.reset = true;
        }

        if (sendToMe) {
            payload.send_me = true;
        }

        return axios.$post('/v1/admin/mailers', payload);
    }
};
